export default __webpack_public_path__ + "static/media/left-mobile-black.0e2f51c4.svg";